import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { BoltDisplayField, BoltDisplayPage } from "@WahooFitness/crux-js-display-cfg";
import { useMemo } from "react";
import SortableWorkoutFieldRow from "./SortableWorkoutFieldRow";

function SortableWorkoutFieldsList({
  fields,
  page,
  openCategoryDialog,
  removeField,
}: {
  fields: BoltDisplayField[];
  page?: BoltDisplayPage | undefined | null;
  openCategoryDialog: (field: BoltDisplayField) => void;
  removeField: (field: BoltDisplayField) => void;
}) {
  const ids = useMemo(() => fields.map((f) => f.getId().toString()), [fields]);

  return (
    <SortableContext items={ids} strategy={verticalListSortingStrategy}>
      {fields.map((field, index) => (
        <SortableWorkoutFieldRow
          key={String(field?.getId() || index)}
          field={field}
          index={index}
          total={fields.length}
          page={page}
          openCategoryDialog={openCategoryDialog}
          removeField={removeField}
        />
      ))}
    </SortableContext>
  );
}

export default SortableWorkoutFieldsList;
